/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box } from "@nordcloud/gnui";
import { ReportsSortFields, SortOrder } from "~/generated/graphql";
import { TableToolbar, TableToolbarSearch } from "~/components";
import { AppliedFiltersSection } from "~/components/AppliedFiltersSection";
import { SortSelector } from "~/components/SortSelector";
import { TABLE_LABELS } from "~/constants";
import { useQueryState } from "~/hooks";
import { useAppliedFilters } from "~/hooks/useAppliedFilters";
import { ReportsQuery } from "~/views/resources/types";
import { reportsAppliedFilters } from "./reportsAppliedFilters";
import { ReportsFiltersSidebar } from "./ReportsFiltersSidebar";
import { ReportsSearch } from "./ReportsSearch";

const sortOptions = [
  {
    value: ReportsSortFields.DateGenerated,
    label: "Date Generated",
  },
  {
    value: ReportsSortFields.CreatedBy,
    label: TABLE_LABELS.createdBy,
  },
];

export function ReportsListHeader({
  resultsCount = 0,
}: {
  resultsCount?: number;
}) {
  const { queryState, updateQueryState } = useQueryState<ReportsQuery>();
  const { field, order } = queryState;
  const appliedFiltersState = useAppliedFilters({
    queryState,
    updateQueryState,
    definitions: reportsAppliedFilters,
  });

  const handleSortDirection = (sortOrder: SortOrder) => {
    updateQueryState({
      order: sortOrder,
    });
  };

  const handleSortField = (sortField: ReportsSortFields) => {
    updateQueryState({
      field: sortField,
    });
  };

  return (
    <Box boxStyle="lightGrey" spacing="spacing04">
      <TableToolbar>
        <SortSelector<ReportsSortFields>
          options={sortOptions}
          value={field ?? ReportsSortFields.DateGenerated}
          direction={order ?? SortOrder.Desc}
          onSelect={handleSortField}
          onSortChange={handleSortDirection}
        />
        <TableToolbarSearch>
          <ReportsSearch />
        </TableToolbarSearch>
        <ReportsFiltersSidebar resultsCount={resultsCount} />
      </TableToolbar>
      <AppliedFiltersSection state={appliedFiltersState} />
    </Box>
  );
}
